import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import messagingService, { MESSAGING_UNREAD_REFRESH_EVENT } from '../../services/messagingService';
import styles from './MessagingNotif.module.css';

const MessagingNotif = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user) {
      setUnreadCount(0);
      return undefined;
    }

    let cancelled = false;

    const fetchUnread = async () => {
      try {
        const data = await messagingService.getUnreadCount();
        const total = typeof data?.total === 'number' ? data.total : 0;
        if (!cancelled) {
          setUnreadCount(total);
        }
      } catch {
        if (!cancelled) {
          setUnreadCount(0);
        }
      }
    };

    fetchUnread();
    const interval = window.setInterval(fetchUnread, 45000);
    const onRefresh = () => {
      fetchUnread();
    };

    window.addEventListener(MESSAGING_UNREAD_REFRESH_EVENT, onRefresh);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
      window.removeEventListener(MESSAGING_UNREAD_REFRESH_EVENT, onRefresh);
    };
  }, [user, location.pathname]);

  if (!user) {
    return null;
  }

  const isActive = location.pathname.startsWith('/messagerie');
  const badgeLabel = unreadCount > 0
    ? `${unreadCount} message${unreadCount > 1 ? 's' : ''} non lu${unreadCount > 1 ? 's' : ''}`
    : undefined;

  return (
    <Link
      to="/messagerie"
      className={`${styles.notifLink} ${isActive ? styles.notifLinkActive : ''}`}
      aria-label={badgeLabel ? `Messagerie — ${badgeLabel}` : 'Messagerie'}
      title="Messagerie"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" className={styles.notifIcon}>
        <path d="M4 5h16v10H8l-4 3V5z" />
      </svg>
      {unreadCount > 0 && (
        <span className={styles.notifBadge} aria-hidden="true">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Link>
  );
};

export default MessagingNotif;
